import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "iconHidden", "iconVisible"]

  toggle() {
    const isPassword = this.inputTarget.type === "password"
    this.inputTarget.type = isPassword ? "text" : "password"
    this.iconHiddenTarget.classList.toggle("hidden", isPassword)
    this.iconVisibleTarget.classList.toggle("hidden", !isPassword)
  }
}
